module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info fa-stack-1x fa-inverse"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bae6eaa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Info.vue
// module id = 80
// module chunks = 2